<template>
  <div id="SchoolCityManage">
    <div v-if="SchoolCityManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <button
          href="#"
          @click="AddSchoolName()"
          class="btn btn-outline-success"
          type="button"
          style="font-size: 14px; text-align: right"
        >
          新增學校名稱
        </button>
      </div>

      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          目前學校共 {{ total }}筆
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 2em">序號</b-th>
                <b-th style="min-width: 5em">地區</b-th>
                <b-th style="min-width: 26em">學校名稱</b-th>
                <b-th style="min-width: 20em">管理</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(item, index) in filteredDocs"
                :key="item.schoolID"
                :index="item.schoolID"
                :name="item.schoolID"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: right">
                  {{ item.schoolID }}
                </b-td>
                <b-td style="text-align: right">
                  {{ item.city }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.schoolName }}
                </b-td>

                <b-td v-if="item.isDelete == false">
                  <button
                    href="#"
                    @click.prevent="EditSchoolName(item.schoolID)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    修改
                  </button>
                  <button
                    href="#"
                    @click.prevent="remove(item.schoolID)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    隱藏
                  </button>
                </b-td>
                <b-td v-else>
                  <button
                    href="#"
                    @click.prevent="EditSchoolName(item.schoolID)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    修改
                  </button>
                  <button
                    href="#"
                    @click.prevent="DisplaySchoolCity(item.schoolID)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    顯示
                  </button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            :limit="21"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>

      <b-modal size="xl" ref="AddSchoolName" hide-footer>
        <template #modal-title> 新增學校名稱 </template>
        <AddSchoolName
          :inputData2="localInputData2"
          @hideModal="hideModal('AddSchoolName')"
        ></AddSchoolName>
      </b-modal>
      <b-modal size="xl" ref="EditSchoolName" hide-footer>
        <template #modal-title> 修改學校名稱 </template>
        <EditSchoolName
          :sn="sn"
          @hideModal="hideModal('EditSchoolName')"
        ></EditSchoolName>
      </b-modal>
      <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認隱藏此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
          >取消隱藏</b-button
        >
        <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
          >隱藏確認</b-button
        >
      </b-modal>
    </div>
  </div>
</template>


<script>
import AddSchoolName from "@/components/AddSchoolName.vue";
import EditSchoolName from "@/components/EditSchoolName.vue";
import * as tools from "../tool";
export default {
  name: "SchoolCityManage",

  data() {
    return {
      courseName: null,
      SchoolCityManageShow: false,
      sn: 0,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      localInputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,

      pageSize: 10,
    };
  },
  components: {
    AddSchoolName,
    EditSchoolName,
  },
  methods: {
    getToday(updateTime) {
      var dd = new Date(updateTime);
      var today = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
      var yyyy = dd.getFullYear();
      return tools.stringFormat("{0}-{1}-{2}", yyyy, mm, today);
    },

    getAllSchoolName() {
  let vm = this;
  this.$http
    .get("./WebApi/HighSchoolEnrolling/GetAllSchoolName/")
    .then((response) => {
      if (!tools.isNull(response)) {

       vm.inputData = response.data;
       vm.total =    response.data.length;

        // 使用Set物件來儲存不重複的CID
        const uniqueCids = new Set();

        // 過濾掉重複的CID，並存放到localInputData2中
        if (vm.inputData != null){
          vm.localInputData2 = vm.inputData.filter((item) => {
          if (!uniqueCids.has(item.cid)) {
            uniqueCids.add(item.cid);
            return true;
          }
          return false;
        });

        }

      }
    })
    .catch(function (error) {
      alert("網路連線失敗" + error);
    });
},
    AddSchoolName() {
      var vm = this;
      vm.$refs["AddSchoolName"].show();
    },
    EditSchoolName(sn) {
      var vm = this;
      vm.sn = sn;
      vm.$refs["EditSchoolName"].show();
    },
    remove(sn) {
      this.sn = sn;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },
    hideModal(name) {
      this.$refs[name].hide();
      this.getAllSchoolName();
    },
    confirmRM() {
      //隱藏資料
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/RemoveSchoolName/".concat(this.sn))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,隱藏成功");
            vm.getAllSchoolName();
          } else {
            tools.showAlert(vm, "danger", "對不起,隱藏失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    DisplaySchoolCity(sn) {
      //display資料
      this.sn = sn;
      var vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/DisplaySchoolCity/".concat(vm.sn))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,顯示成功");
            vm.getAllSchoolName();
          } else {
            tools.showAlert(vm, "danger", "對不起,顯示失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },

    headerColor() {
      return "#f7e8aa";
    },
  },
  created() {
    console.log("======created SchoolCityManageView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.SchoolCityManageShow = true;
    vm.getAllSchoolName();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
